import React, { useState, useEffect } from 'react';
import { AgChartsReact } from 'ag-charts-react';

// 주간 리포트는 월~일 기준이다. dailyValues 도 월요일부터 온다
const DAYS = ['월', '화', '수', '목', '금', '토', '일'];

// const WeeklyBarChart = ({ dailyValues = [], maxValue , threshold, highlightOver = false }) => {
    
    // warnWhen: 'over'  기준치를 넘으면 빨강 (나트륨, 칼로리 섭취)
    //           'under' 기준치에 못 미치면 빨강 (운동시간, 소모 칼로리)
const WeeklyBarChart = ({ dailyValues = [], maxValue, threshold, warnWhen = 'over' }) => {

    const [options, setOptions] = useState(null);
    const dataMax = Math.max(...dailyValues.filter(v => v > 0), threshold || 0, 1);
    
    // 데이터 크기에 따른 올림 단위
    const getRoundUnit = (val) => {
        if (val <= 10)   return 5;
        if (val <= 50)   return 10;
        if (val <= 100)  return 20;
        if (val <= 500)  return 100;
        if (val <= 2000) return 500;
        return 1000;
    };

    const unit = getRoundUnit(dataMax);
    const yMax = Math.ceil(dataMax * 1.3 / unit) * unit;
    
    useEffect(() => {
        // const data = dailyValues.map((v, i) => ({
        //     day: DAYS[i],
        //     value: v,
        //     color: highlightOver && threshold && v > threshold ? '#E55151' : '#1065D9',
        // }));

        // 기록이 없는 날(0)은 경고로 치지 않는다. 안 한 날까지 빨갛게 칠하면 전부 빨강이 된다
        const isWarn = (v) => {
            if (!threshold || v <= 0) return false;

            return warnWhen === 'under' ? v < threshold : v > threshold;
        };

        const data = dailyValues.map((v, i) => ({
            day: DAYS[i],
            value: v,
            color: isWarn(v) ? '#E55151' : '#1065D9',
        }));

        const crossLines = threshold ? [{
            type: 'line',
            value: threshold,
            stroke: '#000', //#E2E6EC
            strokeWidth: 1,
            layer: 'background',
            label: {
                text: threshold.toLocaleString(),
                fontSize: 10,
                color: '#82868C',
                position: 'left',
            },
        }] : [];

        setOptions({
            autoSize: true,
            data,
            series: [{
                type: 'bar',
                xKey: 'day',
                yKey: 'value',
                cornerRadius: 12,
                maxBarWidth: 12,
                formatter: (params) => ({
                    fill: params.datum.color,
                    strokeWidth: 0,
                }),
                label: { enabled: false },
                tooltip: { enabled: false },
            }],
            axes: [
                {
                    type: 'category',
                    position: 'bottom',
                    label: {
                        fontSize: 11,
                        fontFamily: 'Pretendard',
                        fontWeight: '600',
                        color: '#4C5258',
                    },
                    line: {
                        enabled: true,
                        stroke: '#E0E0E0',
                        width: 1,
                    },
                    gridLine: { enabled: false },
                    paddingInner: 0.5,
                },
                {
                    type: 'number',
                    position: 'left',
                    min: 0,
                    max: yMax,
                    nice: false,
                    tick: {
                        values: threshold ? [0, threshold] : [0],
                        size: 0,
                    },
                    label: {
                        fontSize: 10,
                        color: '#A2A6AC',
                        formatter: (params) =>
                            params.value === 0 ? '' : params.value.toLocaleString(),
                    },
                    line: { enabled: false },
                    gridLine: {
                        enabled: Boolean(threshold),
                        style: [
                            { stroke: 'transparent', lineDash: [] },   // 0 라인은 숨김
                            { stroke: '#E0E0E0', lineDash: [] },          // threshold 라인
                        ],
                    },
                    //crossLines,
                },
            ],
            padding: { top: 0, right: 10, bottom: 10, left: 5 },
        });
    // }, [dailyValues, maxValue, threshold, highlightOver]);
    }, [dailyValues, maxValue, threshold, warnWhen]);

    if (!options) return null;

    return (
        <div style={{ width: '100%', height: '14rem', touchAction: 'pan-y', pointerEvents: 'none' }}>
            <AgChartsReact options={options} />
        </div>
    );
};

export default WeeklyBarChart;